"use client";

import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@/src/components/EdgenModal/waitForEdgenModalRoot";
import { finishOnboardingModal } from "@/src/components/ChatOnboarding/shared/finishOnboardingModal";
import { AGGREGATED_ONBOARDING_MODAL_PROPS } from "./aggregatedOnboardingModalShell";
import { AggregatedOnboardingFlowContent } from "./AggregatedOnboardingFlowContent";
import type {
  AggregatedOnboardingFlowResult,
  OpenAggregatedOnboardingModalParams,
} from "./types";

/**
 * 防止重复点击导致叠多个聚合 Modal；与 `pendingPortfolioInsightModal` 独立互不影响。
 */
let pendingAggregatedOnboardingModal: Promise<AggregatedOnboardingFlowResult> | null =
  null;

/**
 * save_goal **聚合弹窗**唯一入口（SaveGoalCard / Setting DEBUG）。
 */
export const openAggregatedOnboardingModal = (
  params: OpenAggregatedOnboardingModalParams = {},
): Promise<AggregatedOnboardingFlowResult> => {
  if (pendingAggregatedOnboardingModal) {
    return pendingAggregatedOnboardingModal;
  }

  pendingAggregatedOnboardingModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<AggregatedOnboardingFlowResult>((resolve) => {
        let settled = false;

        const finish = (result: AggregatedOnboardingFlowResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingAggregatedOnboardingModal = null;

          void finishOnboardingModal(result, {
            handlers: params.handlers,
            onComplete: params.onComplete,
          }).finally(() => {
            EdgenModalCreateAble.end(false);
            resolve(result);
          });
        };

        EdgenModalCreateAble.call({
          children: (
            <AggregatedOnboardingFlowContent
              collectedFields={params.collectedFields}
              loadingBackgroundSrc={params.loadingBackgroundSrc}
              onFinish={finish}
            />
          ),
          ...AGGREGATED_ONBOARDING_MODAL_PROPS,
        });
      }),
  ).catch((error) => {
    pendingAggregatedOnboardingModal = null;
    throw error;
  });

  return pendingAggregatedOnboardingModal;
};
